(() => {
    if (customElements.get('kremo-care-ritual')) return;

    class KremoCareRitual extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        this.details = Array.from(this.querySelectorAll('.kremo-care-ritual__mobile-step'));

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.activate(index));
          tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
        });

        this.details.forEach((detail) => {
          detail.addEventListener('toggle', () => {
            if (!detail.open) return;
            this.details.forEach((other) => {
              if (other !== detail) other.open = false;
            });
          });
        });
      }

      activate(index, focus = false) {
        this.tabs.forEach((tab, tabIndex) => {
          const active = tabIndex === index;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
          if (active && focus) tab.focus();
        });

        this.panels.forEach((panel, panelIndex) => {
          const active = panelIndex === index;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
        });
      }

      onKeydown(event, index) {
        let nextIndex = index;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
        else if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
        else if (event.key === 'Home') nextIndex = 0;
        else if (event.key === 'End') nextIndex = this.tabs.length - 1;
        else return;

        event.preventDefault();
        this.activate(nextIndex, true);
      }
    }

    customElements.define('kremo-care-ritual', KremoCareRitual);
  })();
